import { environment_core } from "./environment.core";

export const environment = {
    ...environment_core,
    production: true,
    envName: 'prod',
    appName: "myadminis"
};
